interface Props {
  onNavigate?: (section: string) => void;
}

export default function Step6PlanNedir({ onNavigate }: Props) {
  const steps = [
    {
      num: 1,
      title: 'Aktif Ol',
      desc: 'Her ay ürün satın alarak sistemde aktif kalırsın. Bu, hem kendi tüketimine değer katarken hem de gelir hakkı kazanmanın temelidir.',
      icon: 'ri-shield-check-line',
      color: 'text-amber-400',
      bg: 'rgba(245,166,35,0.08)',
      border: 'rgba(245,166,35,0.2)',
    },
    {
      num: 2,
      title: 'İlk 4 Kişini Ekle',
      desc: 'Sistemin çekirdeği: Yalnızca 4 kişi. Bu 4 kişi senin direkt ekibini oluşturur. Daha fazlasına gerek yok — odak, nitel büyümededir.',
      icon: 'ri-team-line',
      color: 'text-blue-400',
      bg: 'rgba(0,180,255,0.08)',
      border: 'rgba(0,180,255,0.2)',
    },
    {
      num: 3,
      title: '4 Kişinin 1. Adımı Tamamlamasını Sağla',
      desc: 'Eklediğin 4 kişinin de aktif olmasına ve kendi 4 kişisini eklemesine destek olursun. Çoğalma burada başlar.',
      icon: 'ri-footprint-line',
      color: 'text-green-400',
      bg: 'rgba(34,197,94,0.08)',
      border: 'rgba(34,197,94,0.2)',
    },
    {
      num: 4,
      title: '2. Jenerasyon Büyüyor',
      desc: '4 kişinin her biri kendi 4 kişisini eklediğinde artık 16 kişilik bir ekibin var. Pasif gelirin temeli bu katmanla atılır.',
      icon: 'ri-node-tree',
      color: 'text-purple-400',
      bg: 'rgba(168,85,247,0.08)',
      border: 'rgba(168,85,247,0.2)',
    },
    {
      num: 5,
      title: '3. Jenerasyon — Sistem Çalışıyor',
      desc: '16 kişi kendi ekiplerini kurduğunda 64 kişilik bir ağ oluşur. Bu noktada sistem büyük ölçüde kendi kendine işler.',
      icon: 'ri-bar-chart-grouped-line',
      color: 'text-orange-400',
      bg: 'rgba(255,107,53,0.08)',
      border: 'rgba(255,107,53,0.2)',
    },
    {
      num: 6,
      title: 'Pasif Gelir Gerçeğe Dönüşür',
      desc: 'Her katmandan gelen kazanç, aktiflik bedelini aşar ve kâr etmeye başlarsın. 6. adım; finansal özgürlüğün başlangıcıdır.',
      icon: 'ri-money-dollar-circle-line',
      color: 'text-yellow-400',
      bg: 'rgba(250,204,21,0.08)',
      border: 'rgba(250,204,21,0.2)',
    },
  ];

  const pillars = [
    {
      icon: 'ri-focus-3-line',
      color: 'text-amber-400',
      bg: 'rgba(245,166,35,0.1)',
      title: 'Odak',
      desc: 'Sonsuz kişi aramak yerine yalnızca 4 doğru kişiye odaklanırsın. Az ama güçlü bir ekip kurmak esastır.',
    },
    {
      icon: 'ri-seedling-line',
      color: 'text-green-400',
      bg: 'rgba(34,197,94,0.1)',
      title: 'Kademeli Büyüme',
      desc: 'Her adım bir öncekini besler. Sistem küçük adımlarla inşa edilir, ama etkisi büyük ölçekte hissedilir.',
    },
    {
      icon: 'ri-time-line',
      color: 'text-blue-400',
      bg: 'rgba(0,180,255,0.1)',
      title: 'Pasif Gelir',
      desc: 'Sistemi kurduktan sonra ekibinin üretimi senin adına çalışmaya devam eder. Zaman değil, sistem üretir.',
    },
  ];

  const faqs = [
    {
      q: 'Neden sadece 4 kişi?',
      a: 'Fazla insan yönetmek karmaşıklık yaratır. 4 kişi odaklanılabilir, geliştirilebilir ve takip edilebilir bir sayıdır. Her birini gerçekten başarıya taşıyabilirsin.',
    },
    {
      q: 'Aktiflik bedeli ne işe yarar?',
      a: 'Aktiflik, sistemde gelir hakkı kazanmanın koşuludur. Aynı zamanda kullandığın ürünlere gerçek değer katarsın. Aktif kalmak = gelir hakkı.',
    },
    {
      q: 'Ne zaman kâra geçerim?',
      a: 'Ekibinde aktif üye sayısına ve kazanç planına göre değişir. STEP6 Planım bölümünden tam simülasyonu görebilirsin.',
    },
    {
      q: 'Bu bir piramit sistemi mi?',
      a: 'Hayır. Piramit sistemlerde gelir yalnızca yeni üye kaydından gelir. STEP6\'da gelir; ürün satışına ve aktif ekip büyüklüğüne dayanır. Yasal bir network marketing modelidir.',
    },
  ];

  return (
    <div className="space-y-8">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-white">STEP6 Planı Nedir?</h1>
        <p className="text-sm text-gray-500 mt-1">Sistemin amacı, mantığı ve 6 adımın tam açıklaması</p>
      </div>

      {/* Hero Banner */}
      <div className="relative rounded-2xl overflow-hidden" style={{ minHeight: 180 }}>
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20navy%20background%20with%20glowing%20golden%20geometric%20network%20nodes%20and%20connecting%20lines%2C%20network%20marketing%20concept%2C%20premium%20minimal%20design%2C%20deep%20space%20atmosphere%2C%20gold%20and%20dark%20blue%20gradient&width=1200&height=300&seq=step6hero01&orientation=landscape"
          alt="STEP6 Hero"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg, rgba(8,10,16,0.85) 0%, rgba(8,10,16,0.6) 100%)' }} />
        <div className="relative z-10 p-8 flex flex-col justify-center" style={{ minHeight: 180 }}>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: 'rgba(245,166,35,0.2)' }}>
              <i className="ri-lightbulb-line text-amber-400 text-base" />
            </div>
            <span className="text-xs font-semibold text-amber-400 uppercase tracking-widest">Sistem Tanıtımı</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-black text-white leading-tight mb-3">
            6 Adımda <span style={{ color: '#F5A623' }}>Pasif Gelir</span> Modeli
          </h2>
          <p className="text-sm text-gray-300 max-w-xl leading-relaxed">
            STEP6; herkese açık, öğretilebilir ve tekrarlanabilir bir network büyüme sistemidir.
            Doğru 4 kişiyle başlar, disiplinli bir şekilde ilerler ve zamanla finansal özgürlüğe ulaştırır.
          </p>
        </div>
      </div>

      {/* 3 Temel Sütun */}
      <div>
        <h2 className="text-base font-bold text-white mb-4">Sistemin 3 Temel İlkesi</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {pillars.map((p, i) => (
            <div key={i} className="rounded-2xl p-5" style={{ background: '#12141E', border: '1px solid rgba(255,255,255,0.06)' }}>
              <div className="w-10 h-10 rounded-xl flex items-center justify-center mb-4" style={{ background: p.bg }}>
                <i className={`${p.icon} text-xl ${p.color}`} />
              </div>
              <h3 className="text-sm font-bold text-white mb-2">{p.title}</h3>
              <p className="text-xs text-gray-400 leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* 6 Adım Detayı */}
      <div>
        <h2 className="text-base font-bold text-white mb-4">6 Adımın Tam Açıklaması</h2>
        <div className="space-y-3">
          {steps.map((step) => (
            <div key={step.num} className="rounded-2xl p-5 flex items-start gap-4"
              style={{ background: '#12141E', border: `1px solid ${step.border}` }}>
              <div className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: step.bg }}>
                <span className={`text-lg font-black ${step.color}`}>{step.num}</span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className={`${step.icon} text-sm ${step.color}`} />
                  </div>
                  <h3 className="text-sm font-bold text-white">{step.title}</h3>
                </div>
                <p className="text-xs text-gray-400 leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Gelir Modeli Görsel */}
      <div className="rounded-2xl p-6" style={{ background: '#12141E', border: '1px solid rgba(255,255,255,0.06)' }}>
        <div className="flex items-center gap-2 mb-5">
          <div className="w-8 h-8 rounded-xl flex items-center justify-center" style={{ background: 'rgba(245,166,35,0.1)' }}>
            <i className="ri-flow-chart text-amber-400 text-base" />
          </div>
          <h2 className="text-sm font-bold text-white">Büyüme ve Gelir Modeli</h2>
        </div>
        <div className="grid grid-cols-4 gap-3">
          {[
            { label: 'Sen', count: 1, desc: 'Başlangıç noktası', color: '#F5A623' },
            { label: '1. Jenerasyon', count: 4, desc: 'Direkt ekibindir', color: '#60A5FA' },
            { label: '2. Jenerasyon', count: 16, desc: '4×4 büyüme', color: '#A78BFA' },
            { label: '3. Jenerasyon', count: 64, desc: 'Sistem kendi kendine işler', color: '#34D399' },
          ].map((tier, i) => (
            <div key={i} className="rounded-xl p-4 text-center" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)' }}>
              <div className="text-2xl font-black mb-1" style={{ color: tier.color }}>{tier.count}</div>
              <div className="text-xs font-bold text-white mb-1">{tier.label}</div>
              <div className="text-xs text-gray-500">{tier.desc}</div>
              {i < 3 && (
                <div className="mt-2 flex justify-center">
                  <i className="ri-arrow-right-line text-gray-600 text-sm" />
                </div>
              )}
            </div>
          ))}
        </div>
        <p className="text-xs text-gray-500 mt-4 text-center">
          Toplam potansiyel ağ büyüklüğü: <strong className="text-white">85 kişi</strong> — Sadece 4 kişiyle başlayarak!
        </p>
      </div>

      {/* SSS */}
      <div>
        <h2 className="text-base font-bold text-white mb-4">Sık Sorulan Sorular</h2>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="rounded-2xl p-5" style={{ background: '#12141E', border: '1px solid rgba(255,255,255,0.06)' }}>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: 'rgba(245,166,35,0.1)' }}>
                  <i className="ri-question-line text-amber-400 text-sm" />
                </div>
                <div>
                  <h4 className="text-sm font-bold text-white mb-1.5">{faq.q}</h4>
                  <p className="text-xs text-gray-400 leading-relaxed">{faq.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* CTA */}
      <div className="rounded-2xl p-6 text-center" style={{ background: 'rgba(245,166,35,0.05)', border: '1px solid rgba(245,166,35,0.15)' }}>
        <div className="w-12 h-12 rounded-2xl flex items-center justify-center mx-auto mb-4" style={{ background: 'rgba(245,166,35,0.12)' }}>
          <i className="ri-rocket-2-line text-amber-400 text-2xl" />
        </div>
        <h3 className="text-base font-bold text-white mb-2">Kendi kazanç simülasyonunu gör</h3>
        <p className="text-xs text-gray-400 mb-4">Şirketinin plan rakamlarını girerek kaçıncı adımda kâra geçeceğini hesapla.</p>
        <div className="flex justify-center gap-3">
          <button
            onClick={() => onNavigate?.('step6-plani')}
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-bold text-white cursor-pointer transition-all hover:opacity-90 whitespace-nowrap"
            style={{ background: 'linear-gradient(135deg, #F5A623 0%, #FF6B35 100%)' }}>
            <i className="ri-calculator-line" />
            STEP6 Planıma Git
          </button>
        </div>
      </div>
    </div>
  );
}
